import { useWYSIWYGContext } from '../contexts/WYSIWYGContext';
import { repairHTMLBody, repairHTMLFullDoc } from '../utils';
import { useReplaceContent } from './useReplaceContent';

export const useHandleHtmlCleanup = () => {
  const { isFullHtmlDoc, htmlEditorRef, lastSavedValue } = useWYSIWYGContext();
  const replaceContent = useReplaceContent();

  return () => {
    if (isFullHtmlDoc) {
      const repairedContent = repairHTMLFullDoc(lastSavedValue);
      // Replaces all content (see note below on the renderTiny useEffect)
      replaceContent(repairedContent);
    } else {
      const repairedContent = repairHTMLBody(lastSavedValue);
      htmlEditorRef?.current?.setContent(repairedContent);
    }
  };
};
